/*
 * @Description:
 * @Author: tanglitong
 * @CreationDate: 2023/3/24 11:48
 */
import { userNameReg } from '../../utils/commonReg'

/**
 * @description: 用户名校验
 */
export const validateUsername = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入用户名'))
  } else if (!userNameReg.test(value)) {
    callback(new Error('请输入开头位字母的6-20位字符'))
  } else {
    callback()
  }
}

/**
 * @description: 校验两次密码是否一致
 */
export const validateAgainPassword = (rule, value, callback, password) => {
  if (!value) {
    callback(new Error('请再次输入密码'))
  } else if (value !== password) {
    callback(new Error('两次密码输入不一致'))
  } else {
    callback()
  }
}



// WEBPACK FOOTER //
// ./src/components/ChangePassword/index.js